export default "__VITE_ASSET__CwDP_$8d__"